import { render, staticRenderFns } from "./UserRights.vue?vue&type=template&id=22b5e517&scoped=true&"
import script from "./UserRights.vue?vue&type=script&lang=js&"
export * from "./UserRights.vue?vue&type=script&lang=js&"
import style0 from "./UserRights.vue?vue&type=style&index=0&id=22b5e517&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5e517",
  null
  
)

export default component.exports